import createEditManageWorkOrderType from '../modals/createEditManageWorkOrderType/lan/en';
import deleteManageWorkOrderType from '../modals/deleteManageWorkOrderType/lan/en';

export default {
    manage_workOrderType_name: "Name",
    manage_workOrderType_form: "Form",
    manage_workOrderType_estimatedDuration: "Estimated Duration",
    manage_workOrderType_description: "Description",
    manage_workOrderType_search_by_name_form_description: "Search by Name, Form or Description",
    ...createEditManageWorkOrderType,
    ...deleteManageWorkOrderType,
}